module.exports = __webpack_public_path__ + "static/media/placeholder_image.896ed802.png";